import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'core/api/api.service';
import { AppInfoService } from 'core/app-info/app-info.service';
import { EmailPattern } from 'core/common-entities/email-pattern.class';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-accounts-email',
  templateUrl: './accounts-email.component.html',
  styleUrls: ['./accounts-email.component.scss'],
  standalone: false
})

export class AccountsEmailComponent implements OnInit {
  selectForm;
  email = new UntypedFormControl(['', [
    Validators.required,
    Validators.pattern(EmailPattern.pattern),
    Validators.maxLength(100)]]);
  private urlAccount = '/api/email/leads/account';
  atpValues: any;
  element: any;
  appStrings = this.appInfoService.appStrings;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<AccountsEmailComponent>,
    private formBuilder: UntypedFormBuilder,
    public apiService: ApiService,
    private appInfoService: AppInfoService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.element = data;
  }

  ngOnInit() {
    this.selectForm = this.formBuilder.group({
      email: ['', [
        Validators.required,
        Validators.pattern(EmailPattern.pattern),
        Validators.maxLength(100)]]
    });
  }

  close(result?): void {
    this.dialogRef.close(result);
  }

  sendAccountEmailDetails(accountId) {
    if (this.selectForm.valid) {
      this.loading = true;
      this.apiService.post(this.urlAccount, { id: accountId, email: this.selectForm.controls.email.value })
        .pipe(finalize(() => this.loading = false))
        .subscribe(result => this.close(result));
    }
  }
}
